export enum PercentageCalculationRule {
    PercentageOfTarget = 'PercentageOfTarget',
    PercentageOfCurrentPay = 'PercentageOfCurrentPay'
}